import { useTranslations } from '@vocab/react';
import { Card, Stack, Text } from 'braid-design-system';

import { Permissions } from 'src/App/Components/Permissions/Permissions';
import type { User } from 'src/graphql/generated';

import translations from '../.vocab';
import { Td, Tr } from '../Table/Table';

import { StatusBadges } from './StatusBadges';
import { UserActions } from './UserActions';
import { UserName } from './UserName';

export interface UserRowProps {
  user: User;
  removeUser: (user: User) => void;
  accountHasPremiumTalentSearch?: boolean;
}

export const UserCard = ({
  user,
  removeUser,
  accountHasPremiumTalentSearch,
}: UserRowProps) => {
  const { t } = useTranslations(translations);
  return (
    <Card>
      <Stack space="large">
        <Stack space="small">
          <StatusBadges role={user.permissions.role} status={user.status} />
          <UserName {...user} />
          <Text data={{ 'dd-privacy': 'mask', 'hj-masked': true }}>
            {user.email}
          </Text>
        </Stack>

        <Stack space="small">
          <Text weight="medium">{t('Permissions column')}</Text>
          <Permissions
            accountHasPremiumTalentSearch={accountHasPremiumTalentSearch}
            permissions={user.permissions}
          />
        </Stack>
        <UserActions user={user} removeUser={removeUser} />
      </Stack>
    </Card>
  );
};

export const UserRow = ({
  user,
  removeUser,
  accountHasPremiumTalentSearch,
}: UserRowProps) => (
  <Tr id={`user-row-${user.id}`} marginBottom="small">
    <Td paddingLeft="medium" paddingY="medium">
      <Stack space="small">
        <StatusBadges role={user.permissions.role} status={user.status} />
        <UserName {...user} />
        <Text
          data={{
            'dd-privacy': 'mask',
            'hj-masked': true,
            testid: 'memberList-email',
          }}
          maxLines={1}
        >
          {user.email}
        </Text>
      </Stack>
    </Td>
    <Td padding="medium">
      <Permissions
        accountHasPremiumTalentSearch={accountHasPremiumTalentSearch}
        permissions={user.permissions}
      />
    </Td>
    <Td paddingRight="medium" paddingY="medium">
      <UserActions user={user} removeUser={removeUser} />
    </Td>
  </Tr>
);
